import React, { Component } from 'react';
import { Row, Col, Card } from 'antd';
import { NewSignalForm } from './NewSignalForm';
import { RecentSignalsTable } from './RecentSignalsTable';

export class CopyTradingView extends Component {
    render() {
        return (
            <Row gutter={24} type="flex" justify="center">
                <Col md={12}>
                    <Card title="New Signal" bordered={false}>
                        <NewSignalForm />
                    </Card>
                </Col>

                <Col md={24} style={{ marginTop: 15 }}>
                    <Card title="Recent Signals" bordered={false}>
                        <RecentSignalsTable />
                    </Card>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/CopyTradingView/index.js